import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
import {PaymentSupportService} from "../flash-payment/flash-payment-core/services/payment-support.service";

@Component({
  selector: 'app-bills-management',
  templateUrl: './bills-management.component.html',
  styleUrls: ['./bills-management.component.sass']
})
export class BillsManagementComponent implements OnInit {
  public tabActive='Factura y Pago';
  isLoading = false;
  public selectBan;
  public banlist;
  public billDueDateField;
  public cycleStartDateField;
  public cycleEndDateField;
  public billBalanceField;
  public cycleDateField;
  public lastPaymentAmountField;
  public amountPayable2;
  public amountPayable;
  public dopaymentmount;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token:string=sessionStorage.getItem("token");
  loadObserver: Subscription;
  initialize: Subscription;
  constructor(
      private router:Router,
      private loadingScreenService :LoadingScreenService,
      private services: Service,
      public global:GlobalService,
      public AngularFireAnalytics:AngularFireAnalytics,
      private paymentSupportServices: PaymentSupportService
      ) {
    this.AngularFireAnalytics.setCurrentScreen("Resumen de Factura");
    this.AngularFireAnalytics.logEvent("Resumen de Factura-Screenview");
  }

  ngOnInit() {
    this.global.validateSession();
    if(this.global.sessionReview()==true){
      this.banlist=JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
      this.lastPaymentAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastPaymentAmountField;
      this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
      this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
      this.cycleEndDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleEndDateField;
      this.cycleStartDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleStartDateField;
      this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
      this.paymentAmount();
      this.loadingScreenService.stopLoading();
      this.initialize = this.global.initialize.subscribe((value:number) => {
        this.initializeData();
      });
      this.loadObserver = this.global.loadObserver.subscribe((value:number) => {
        this.dataLoading(value)
      });
    }
  }

  refreshDataTo(event:Event) {
    let index =parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan",btoa(ban));
    this.initializeData();
  }
  initializeData(){
    this.loadingScreenService.startLoading();
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw){
    this.loadingScreenService.stopLoading();
    this.lastPaymentAmountField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastPaymentAmountField;
    this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
    this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
    this.cycleEndDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleEndDateField;
    this.cycleStartDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleStartDateField;
    this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
    this.paymentAmount();

  }
  ngOnDestroy() {
    this.loadObserver.unsubscribe();
  }
  paymentAmount(){
    if (this.billBalanceField.search('CR') > -1) {
      this.amountPayable2="$"+this.billBalanceField;
    }
    else {
      this.amountPayable = this.billBalanceField;
      this.amountPayable2="$"+this.amountPayable;
    }
    this.checkAmount();
  }

  doPayment(){
    this.amountPayable2=this.amountPayable2.replace( '$','');
    this.amountPayable2="$"+this.amountPayable2;
    this.amountPayable=this.amountPayable2.replace( '$','');
    let mount = parseFloat(String(this.amountPayable).replace(',', ''));
    if (mount>=5 && mount <=2000) {
      let typeMessage='payment';
      if(this.prepago==true){
        typeMessage='prepaid';
      }
      this.global.validateSession();
      if (sessionStorage.getItem('canUseNewMethod')) {
        this.paymentSupportServices.paymentRefactorProcess(typeMessage, this.amountPayable, this.selectBan, this.token);
      } else {
        this.oldProcess(typeMessage);
      }
    }
    


  }

  oldProcess(typeMessage) {
    let mount = parseFloat(String(this.amountPayable).replace(',', ''));
    this.global.newPayment(1,typeMessage,this.selectBan,atob(sessionStorage.getItem("defaultSubscriber")),(mount).toString(),atob(sessionStorage.getItem("email")),sessionStorage.getItem("name"),"",this.token);
    this.global.doPayment(this.selectBan,mount,sessionStorage.getItem("token"));
  }

  checkAmount(){
    this.amountPayable2=this.amountPayable2.replace( '$','');
    this.amountPayable2="$"+this.amountPayable2;
    this.amountPayable=this.amountPayable2.replace( '$','');
    let mount = parseFloat(String(this.amountPayable).replace(',', ''));
    if(mount>=5 && mount <=2000){
      this.dopaymentmount=true;
    }
    else{
      this.dopaymentmount=false;
    }
  }

  validateAmount() {
    if ((Number(this.amountPayable) >= 5 ) || (Number(this.amountPayable) <= 2000))  {
      this.dopaymentmount=true;
    } else {
      this.dopaymentmount=false;
    }
  }

  fix(num){
    return parseFloat(num).toFixed(2);
  }
}
